import component from './component'

export default {
    path: '/user',
    name: 'user',
    component: component
}



// WEBPACK FOOTER //
// ./src/components/account/index/index.js